import { injectable } from "inversify";
import { EventAggregationService } from '@/platform/EventAggregationService';
import { QueryParametersState } from "./QueryParametersState";
import { ISubscriber } from "@studyportals/event-aggregation-service-interface";
import { EmbeddedStateChangedEvent } from "./events/EmbeddedStateChangedEvent";


@injectable()
export class QueryParameterSelection implements ISubscriber<EmbeddedStateChangedEvent> {

	private _state = new QueryParametersState();

	public constructor(
		eventAggregationService: EventAggregationService
	) {
		eventAggregationService.subscribeTo(EmbeddedStateChangedEvent.EventType, this);
	}

	public notify(event: EmbeddedStateChangedEvent): void | Promise<void> {
		this.commit(event.state.queryParameters);
	}

	public get state(): QueryParametersState {
		return this._state;
	}

	private normalize(state: QueryParametersState): QueryParametersState {
		return state.removeInvalidEntries(state);
	}

	private commit(other: QueryParametersState): void {
		if (this.state.isEqual(other)) {
			return;
		}

		this._state = this.normalize(other);
	}
}